var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 146,
    viewBox: "0 0 194 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    y: 0.60791,
    width: 193.167,
    height: 145,
    rx: 10,
    fill: "#1E2631"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13148_15186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.833 40.0021H103.833V31.0021C103.833 30.1081 103.437 29.2621 102.747 28.6921C102.063 28.1221 101.145 27.8761 100.281 28.0561L52.281 37.0561C50.859 37.3201 49.833 38.5561 49.833 40.0021V106.002C49.833 107.442 50.859 108.684 52.281 108.948L100.281 117.948C100.461 117.984 100.647 118.002 100.833 118.002C101.529 118.002 102.207 117.762 102.747 117.312C103.437 116.742 103.833 115.89 103.833 115.002V106.002H142.833C144.489 106.002 145.833 104.658 145.833 103.002V43.0021C145.833 41.3461 144.489 40.0021 142.833 40.0021ZM139.833 100.002H103.833V94.0021H112.833C114.489 94.0021 115.833 92.6581 115.833 91.0021C115.833 89.3461 114.489 88.0021 112.833 88.0021H103.833V82.0021H112.833C114.489 82.0021 115.833 80.6581 115.833 79.0021C115.833 77.3461 114.489 76.0021 112.833 76.0021H103.833V70.0021H112.833C114.489 70.0021 115.833 68.6581 115.833 67.0021C115.833 65.3461 114.489 64.0021 112.833 64.0021H103.833V58.0021H112.833C114.489 58.0021 115.833 56.6581 115.833 55.0021C115.833 53.3461 114.489 52.0021 112.833 52.0021H103.833V46.0021H139.833V100.002Z",
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8744 77.1846L82.4323 73.0313C77.0572 73.6036 64.5742 78.3767 63.1372 88.1951C58.5972 79.1864 66.1985 65.6187 81.4695 63.9927L81.0444 60L92.9609 67.9924L82.8744 77.1846Z",
    fill: "#2FF29E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.833 52.002H124.833C123.177 52.002 121.833 53.346 121.833 55.002C121.833 56.658 123.177 58.002 124.833 58.002H130.833C132.489 58.002 133.833 56.658 133.833 55.002C133.833 53.346 132.489 52.002 130.833 52.002Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.833 64.002H124.833C123.177 64.002 121.833 65.346 121.833 67.002C121.833 68.658 123.177 70.002 124.833 70.002H130.833C132.489 70.002 133.833 68.658 133.833 67.002C133.833 65.346 132.489 64.002 130.833 64.002Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.833 76.002H124.833C123.177 76.002 121.833 77.346 121.833 79.002C121.833 80.658 123.177 82.002 124.833 82.002H130.833C132.489 82.002 133.833 80.658 133.833 79.002C133.833 77.346 132.489 76.002 130.833 76.002Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.833 88.002H124.833C123.177 88.002 121.833 89.346 121.833 91.002C121.833 92.658 123.177 94.002 124.833 94.002H130.833C132.489 94.002 133.833 92.658 133.833 91.002C133.833 89.346 132.489 88.002 130.833 88.002Z",
    fill: "#F4A024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13148_15186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(49.833 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.05443ed5804bb9982087d55c24a86be8.svg";
export { ForwardRef as ReactComponent };